import * as React from 'react';

const Instagram = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1380-1246H540v4595h-1920z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M5.556 0A5.556 5.556 0 0 0 0 5.556v8.888A5.556 5.556 0 0 0 5.556 20h8.888A5.556 5.556 0 0 0 20 14.444V5.556A5.556 5.556 0 0 0 14.444 0zm11.11 2.222c.612 0 1.112.5 1.112 1.111s-.5 1.111-1.111 1.111-1.111-.5-1.111-1.11c0-.612.5-1.112 1.11-1.112M10 4.444a5.556 5.556 0 1 1 0 11.112 5.556 5.556 0 0 1 0-11.112m0 2.223a3.334 3.334 0 0 0 .002 6.669A3.335 3.335 0 0 0 10 6.666"
            />
        </g>
    </svg>
);
export default Instagram;
